<template>
  <div class="s-info">
    <div v-if="!infoText" class="s-info__done" :class="{ failed: !isDone }">
      {{ isDoneText }}
    </div>
    <div v-else class="s-info__info-text" :class="{ success: isSuccess }">
      {{ infoText }}
    </div>
  </div>
</template>

<script>
export default {
  name: "StepInfo",
  props: {
    isDone: {
      type: Boolean,
      default: true,
    },
    infoText: {
      type: String,
      default: "",
    },
    isSuccess: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isDoneText() {
      return this.isDone ? "Выполнено" : "Не выполнено";
    },
  },
};
</script>

<style lang="less" scoped>
.s-info {
  display: flex;
  align-items: center;
  font-size: @font-size-s;
  line-height: @line-height-s;
  font-weight: 700;
  &__done {
    background-color: @blue-color;
    padding: 5px 10px;
    border-radius: @border-radius-xs;
    color: @info-color;

    &.failed {
      border: 1px solid @gray-color;
      background-color: #fff;
      color: @dark-gray-color;
      padding: 4px 10px;
    }
  }

  &__info-text {
    border-radius: @border-radius-xs;
    border: 1px solid @gray-color;
    background-color: #fff;
    color: @dark-gray-color;
    padding: 4px 10px;

    &.success {
      border-color: @info-color;
      color: @info-color;
    }
  }
}
</style>
